"use client";

import {
  spacing,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";

import type { WikiAuthor, WikiLinkRenderer } from "./wiki-types";
import * as stylex from "@stylexjs/stylex";

export function WikiAuthorName({
  author,
  renderLink,
}: Readonly<{
  author: WikiAuthor;
  renderLink: WikiLinkRenderer;
}>) {
  return (
    <span {...stylex.props(localStyles.author)}>
      <span
        {...stylex.props(author.kind === "player" && localStyles.playerName)}
      >
        {author.href
          ? renderLink({ href: author.href, children: author.displayName })
          : author.displayName}
      </span>
      {author.kind === "player" && (
        <span {...stylex.props(localStyles.playerKind)}>player</span>
      )}
    </span>
  );
}

const localStyles = stylex.create({
  author: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: spacing.space6,
    color: colors.foreground,
    overflowWrap: "anywhere",
  },
  playerName: { fontFamily: fonts.mono },
  playerKind: {
    fontSize: fontSizes.caption,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
});
